import { TableColumn } from "../../../../Component/Model/Table/Table"
import { barrierCategoryFormatter, DataTableHtmlFormatter, TableDateHelper, YesNoValue } from "../../../../Component/Model/helpers";
import { EEBarrier } from "../../../../Component/Model/Dto/EmploymentEquity/Plan/EEBarriers";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { ActionsCellWithBadge } from "../../../../Component/Common/Components/DataTable/ActionsCellWithBadge";
interface BarriersRow {
    Id: number;
    EeBarrierCategoryId: string;
    ResponsibleDesignation: string;
    Policy: string;
    Procedure: string;
    Practice: string;
    Barriers: string;
    AffirmativeActionMeasured: string;
    StartDate: string;
    EndDate: string;
    SupportingDocuments: any;
    SourceScorecard: React.ReactNode;
    Actions?: any;
}

interface BarrierTable {
    columns: Array<TableColumn>;
    rows: Array<BarriersRow>;
}

export function EEBarriersTableMapper(
    dataObject: EEBarrier.SearchResult[], 
    handleEdit: (id: string) => void, 
    handleDelete: (id: string) => void, 
    handleAttachedSD: (id: string) => void, 
    handleToggleDocumentPack: (id: string) => void,
    isConsolidated: boolean): BarrierTable {
    const columns = [
        { Header: 'Category', accessor: 'EeBarrierCategoryId', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Policy', accessor: 'Policy', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Procedure', accessor: 'Procedure', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Practice', accessor: 'Practice', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Barriers', accessor: 'Barriers', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Affirmative Action Measures', accessor: 'AffirmativeActionMeasured', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Start Date', accessor: 'StartDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'End Date', accessor: 'EndDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Responsibility', accessor: 'ResponsibleDesignation', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Supporting Documents', accessor: 'SupportingDocuments', Cell: ({ value }: any) => <ActionsCellWithBadge actions={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (isConsolidated) {
        columns.splice(10, 0, { Header: 'Source Scorecard', accessor: 'SourceScorecard', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />, disableSortBy: true });
    }
    
    if (dataObject.length > 0) {
        const rows = dataObject.map((item: EEBarrier.SearchResult) => ({
            Id: item.id,
            EeBarrierCategoryId: barrierCategoryFormatter(item.eeBarrierCategoryId),
            Policy: YesNoValue(item.policy),
            Procedure: YesNoValue(item.procedure),
            Practice: YesNoValue(item.practice),
            Barriers: DataTableHtmlFormatter(item.barriers, ' '),
            AffirmativeActionMeasured: DataTableHtmlFormatter(item.affirmativeActionMeasured, ' '),
            ResponsibleDesignation: item.responsibleDesignation,
            StartDate: TableDateHelper(item.startDate.toString()) ?? "",
            EndDate: TableDateHelper(item.endDate.toString()) ?? "",
            SupportingDocuments: item.documentsSelectedForDownload ? [
                { label: `${item.documentCount} Supporting Document(s)`, action: handleAttachedSD, key: item.id, icon: { color: 'info', name: 'attach_file' }, badgeCount: item.documentCount },
                // { label: 'Remove Documents from Download Pack', action: handleToggleDocumentPack, key: item.id, icon: { color: 'secondary', name: 'bookmark_remove' } }
            ] :
                [
                    { label: `${item.documentCount} Supporting Document(s)`, action: handleAttachedSD, key: item.id, icon: { color: 'info', name: 'attach_file' }, badgeCount: item.documentCount },
                    // { label: 'Add Documents to Download Pack', action: handleToggleDocumentPack, key: item.id, icon: { color: 'secondary', name: 'bookmark_add' } },
                ],
            SourceScorecard: item.sourceScorecardName ?? <i>None</i>,
            Actions: [{ label: 'View/Edit', action: handleEdit, key: item.id, icon: { color: 'info', name: 'edit' } },
            { label: 'Delete', action: handleDelete, key: item.id, icon: { color: 'error', name: 'delete' } }]

        }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}


